// IMPORTAÇÃO DAS BIBLIOTEACS----------------------------------------------------------------------
import React from "react";
import { Link, useRouteError, isRouteErrorResponse } from "react-router-dom";
import { useTranslation } from 'react-i18next';



// IMPORTAÇÃO DOS COMPONENTES----------------------------------------------------------------------
import styles from './errorPage.module.css';



// COMPONENTE--------------------------------------------------------------------------------------
const ErrorPage = ({
    code: propCode,
    message: propMessage,
    showGoBackButton = true
}) => {
    const { t } = useTranslation(); // hook para traduzir
    const error = useRouteError();
    let code = propCode || "Oops!";
    let message = propMessage || "Something went wrong. Please try again.";

    if (isRouteErrorResponse(error)) {
        // Erros de rota, como 404 (Não Encontrado) ou erros de loaders/actions.
        code = error.status;
        message = error.statusText || "An error occurred.";
        if (error.data?.message) {
            message = error.data.message;
        }
    } else if (error instanceof Error) {
        // Outros erros que podem ocorrer na aplicação (ex: erros de renderização).
        console.error(error);
        message = error.message;
    }

    return (
        <div className={styles.container}>
            <h1 className={styles.title}>{code}</h1>
            <p className={styles.message}>{message}</p>
            {showGoBackButton && (
                <Link to="/" className={styles.link}>
                    {t("Return to homepage")}
                </Link>
            )}
        </div>
      );
}

export default ErrorPage;